import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Table } from "react-bootstrap";

const NotaCreditoPrint = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // 🚨 CAMBIO: Se añaden idNotaCredito (largo) y numeroNotaCredito (corto, práctico)
  const { 
    ventaOriginal, 
    itemsDevueltos, 
    totalDevuelto, 
    idNotaCredito, 
    numeroNotaCredito ,
    fechaEmisionNC
  } = location.state || {};

  if (!ventaOriginal) {
    return (
      <div className="container mt-5">
        <h3>No hay datos para generar la nota de crédito</h3>
        <Button onClick={() => navigate(-1)}>Volver</Button>
      </div>
    );
  }

  //IMPRIMIR EN 58MM

  const imprimirNotaCredito58mm = async () => {
  if (!window.qz) {
    alert("QZ Tray no está corriendo");
    return;
  }

  if (!window.qz.websocket.isActive()) {
    await window.qz.websocket.connect();
  }

  const config = window.qz.configs.create("XP-58");

  const fecha =   fechaEmisionNC
    ? new Date(fechaEmisionNC).toLocaleString("es-AR")
    : "N/A"

  const data = [
    "\x1B\x40",          // INIT
    "\x1B\x61\x01",      // CENTER
    "TIENDA COLIBRIES\n",
    "NOTA DE CREDITO\n",
    "\n",
    `NC Num: ${numeroNotaCredito}\n`,
    "\x1B\x61\x00",      // LEFT
    "------------------------------\n",
    `Venta: ${ventaOriginal.ticketId || ventaOriginal.id}\n`,
    `${fecha}\n`,
    "------------------------------\n",
  ];

  itemsDevueltos.forEach((p) => {
    data.push(
      `${p.nombre.substring(0, 20)}\n`,
      `x${p.cantidad}   $${p.subtotal.toFixed(2)}\n`
    );
  });

  data.push(
    "------------------------------\n",
    `TOTAL DEVUELTO:\n`,
    `$${totalDevuelto.toFixed(2)}\n`,
    "\n",
    "\x1B\x61\x01",
    "NO VALIDO COMO FACTURA\n",
    "GRACIAS\n",
    "\n\n",
    "\x1D\x56\x41"       // CUT
  );

  await window.qz.print(config, data);
};



  return (
    <div className="container mt-4" id="nota-credito">
      <h2 className="text-center mb-4">NOTA DE CRÉDITO</h2>

      {/* ✅ CAMBIO: Mostrar el número práctico de NC generado */}
      <h3 className="text-primary mb-3 text-center">N° NC: {numeroNotaCredito}</h3>
      <p className="text-center text-muted">ID Interno: {idNotaCredito}</p>
      
      <hr />

      <p><b>Venta original:</b> {ventaOriginal.ticketId || ventaOriginal.id}</p>
      {/* Nota: Usamos la fecha de la venta original, que puede ser un objeto Timestamp */}
   <p>
  <b>Fecha de emisión:</b>{" "}
  {fechaEmisionNC
    ? new Date(fechaEmisionNC).toLocaleString("es-AR")
    : "N/A"}
</p>
      <p><b>Vendedor:</b> {ventaOriginal.vendedor?.nombre}</p>

      <hr />

      <Table bordered size="sm">
        <thead>
          <tr>
            <th>Producto</th>
            <th>Cant.</th>
            <th>Precio Final Unit.</th>
            <th>Subtotal</th>
          </tr>
        </thead>
        <tbody>
          {itemsDevueltos.map((p, index) => (
            <tr key={index}>
              <td>{p.nombre}</td>
              <td>{p.cantidad}</td>
              <td>${p.precioFinalUnitario.toFixed(2)}</td>
              <td>${p.subtotal.toFixed(2)}</td>
            </tr>
          ))}
        </tbody>
      </Table>

      <h4 className="text-end mt-3">
        TOTAL NOTA DE CRÉDITO: ${totalDevuelto.toFixed(2)}
      </h4>

      <div className="d-flex justify-content-between mt-4">
        <Button variant="secondary" onClick={() => navigate(-1)}>
          Volver
        </Button>

      <Button variant="primary" onClick={imprimirNotaCredito58mm}>
  Imprimir NC 58mm
</Button>

      </div>
    </div>
  );
};

export default NotaCreditoPrint;